// @custom — Product-specific text overrides. NEVER overwritten during template sync.
// Override any text from @system/text/index.js here.
// Deep-merged: only keys you set will override — everything else falls through.

export const text = {
  landing: {
    hero: {
      title: "Cluboria",
      subtitle: "Your Club. Your Tactics. Your Legacy.",
    },
  },
  auth: {
    loginTitle: "Sign in to Cluboria",
    registerTitle: "Create your Cluboria account",
  },
}
